import React, { Component } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SimpleReactValidator from 'simple-react-validator';
import { history } from '../../../shared/configure-store';
import { toast, ToastContainer } from 'react-toastify';
import { Link, withRouter } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import Width from '../../../images/width.png';
import Height from '../../../images/height.png';
import Length from '../../../images/length.png';
import Api from '../../../libraries/api';
import { bindActionCreators } from "redux";
import { RootActions } from "../../../shared/root-action";
import { connect } from "react-redux";
import language from "../../../libraries/label-lang";
import AuthHelper from "../../../libraries/auth-helper";
import templateId from "../../../libraries/lang-id";
import NumberFormat from 'react-number-format';
import _ from 'lodash';

SimpleReactValidator.addLocale('indo', templateId);


class ProductsAdd extends Component {

    constructor(props) {

        super(props);


        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );


        this.state = {
            loading: false,
            loadingButton: false,

            errors: [],

            warehouseList: [],
            reservationList: [],
            storageList: [],

            skuNumber: '',
            image_name: '',
            image: '',
            name: '',
            storage: '',
            category: '',
            category_other: '',
            weight: '',
            width: '',
            height: '',
            length: '',
            supliedPackaging: '',
            otherpackaging: '',
            shelfLife: '',
            price: '',
            description: '',
        }
    }

    componentDidMount() {

        document.title = 'Fresh Factory - Add Product';

        Api.get('/warehouses').then(resp => {
            if (resp.data) {

                this.setState({
                    warehouseList: resp.data,
                    loading: false,
                })

            }
        }).catch(err => {
            this.showMessage(false, err.message);
        });

        Api.get('/storage').then(resp => {
            if (resp.data) {

                this.setState({
                    storageList: resp.data,
                    loading: false,
                })

            }
        }).catch(err => {
            this.showMessage(false, err.message);
        });

    };

    UNSAFE_componentWillReceiveProps() {

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );
    }

    __fetchLockerSize = (w, h, l, s) => {

        this.setState({

            loading3: true

        });

        let data = {
            width: w,
            height: h,
            length: l,
            storage: s,
        };
        Api.post('/lockersize/find', data).then(resp => {

            if (resp.data.length === 0) {
                this.setState({
                    lockerSizeName: 0,
                    loading3: false
                });

                return false
            }
            if (resp.data) {
                this.setState({
                    lockerSizeName: resp.data.name,
                    lockerSizeId: resp.data.id,
                    loading3: false
                });
            }

        }).catch(err => {
            console.log(err);
        });
    };


    handleChange(e, prop) {
        this.setState({

            [prop]: e.target.value

        }, () => {

            if (prop === 'width' || prop === 'height' || prop === 'length' || prop === 'storage') {
                if (this.state.width && this.state.height && this.state.length && this.state.storage) {
                    this.__fetchLockerSize(this.state.width, this.state.height, this.state.length, this.state.storage)
                }
            }

        });

    };

    handleGo = (link) => {
        history.push(link);
    };

    showMessage = (status, message) => {
        if (status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        } else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleUpload = e => {

        let temp = _.get(e, 'target.files[0]', false);

        this.setState({
            errors: { image: '' },
        });

        if (temp) {
            if (e.target.files[0].size > 999999) {

                this.setState({
                    errors: {
                        image: 'This file is too big. Maximum size is 1MB.'
                    },
                });

            } else if (e.target.files[0].name.toLowerCase().search('.jpeg') === -1 &&
                e.target.files[0].name.toLowerCase().search('.jpg') === -1 &&
                e.target.files[0].name.toLowerCase().search('.png') === -1) {

                this.setState({
                    errors: {
                        image: 'This file is invalid. Only accept .jpg, .jpeg and .png'
                    },
                });

            } else {

                this.setState({
                    image: URL.createObjectURL(e.target.files[0]),
                    image_file: e.target.files[0],
                    image_name: e.target.files[0].name,
                });

            }
        }
    };

    handleSubmit = (e) => {

        e.preventDefault();

        if (!this.validator.allValid()) {

            this.setState({
                errors: this.validator.getErrorMessages()
            }
            );

            return false;

        }

        this.setState({
            errors: {},
            loadingButton: true
        }
        );

        let formData = new FormData();
        formData.append('skuNumber', this.state.skuNumber);
        formData.append('name', this.state.name);
        formData.append('storage', this.state.storage);
        formData.append('category', this.state.category === 'Other' ? this.state.category_other : this.state.category);
        formData.append('width', this.state.width);
        formData.append('height', this.state.height);
        formData.append('length', this.state.length);
        formData.append('weight', this.state.weight);
        formData.append('supliedPackaging', this.state.supliedPackaging === 'Other' ? this.state.otherpackaging : this.state.supliedPackaging);
        formData.append('shelfLife', this.state.shelfLife);
        formData.append('description', this.state.description);
        formData.append('lockerSizeId', this.state.lockerSizeId);
        formData.append('price', this.state.price);
        if (this.state.image_file) {
            formData.append('image', this.state.image_file);
        }

        Api.putFile('/products', {
            method: 'POST',
            body: formData
        }).then(resp => {

            this.setState({
                newlyCreatedProductId: resp.data.id,

                skuNumber: '',
                name: '',
                storage: '',
                category: '',
                category_other: '',
                width: '',
                height: '',
                length: '',
                weight: '',
                supliedPackaging: '',
                otherpackaging: '',
                shelfLife: '',
                description: '',
                lockerSizeId: '',
                lockerSizeName: '',
                price: '',
                image_file: '',
                image: '',
                image_name: '',
                reservationId: this.state.reservationId
            });

            this.showMessage(true, 'Product successfully added');
            this.handleGo('/products');

        }).catch(err => {

            if (err.errors) {
                this.setState({
                    errors: err.errors,
                    loadingButton: false
                }
                );
                this.showMessage(false, err.errors);
            } else {
                this.setState(
                    {
                        loadingButton: false
                    }
                );
                this.showMessage(false, err.message);
            }



        });


    };

    NumberFormatCustom = (props) => {
        const { inputRef, onChange, ...other } = props;

        return (
            <NumberFormat
                {...other}
                getInputRef={inputRef}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                allowedDecimalSeparators={[',']}
                thousandSeparator={'.'}
                decimalSeparator={','}
                fixedDecimalScale={false}
                isNumericString
            />
        );
    };

    formatStorage = (name) => {
        if(name === 'Frozen') {
            return 'Beku';
        }else if(name === 'Chilled') {
            return 'Dingin';
        }else if(name === 'Dry') {
            return 'Kering';
        }
    };

    render() {

        let lang = {};
        if (this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        } else {
            lang = language.en;
        }
        const text = lang;

        return (

            <div className='dashboard-detail'>

                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        <li className='breadcrumb-item'><Link to='/' >{text.label_dashboard}</Link></li>
                        <li className='breadcrumb-item'><Link to='/products' >{text.label_products}</Link></li>
                        <li className='breadcrumb-item active' aria-current='page'>{text.button_add}</li>
                    </ol>
                </nav>

                <div className='row'>
                    <div className='col-lg-8 col-xl-7'>
                        <div className='card-white'>
                            <h2 className='text-uppercase'>{text.button_add} {text.label_products}</h2>

                            <form name='add' id='addProduct' className='row' noValidate>
                                <div className='col-12 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='skuNumber'
                                            name='skuNumber'
                                            label={text.label_sku}
                                            onChange={(e) => this.handleChange(e, 'skuNumber')}
                                            value={this.state.skuNumber}
                                            fullWidth
                                        />
                                        {this.validator.message('skuNumber', this.state.skuNumber, 'required')}
                                        <div className='text-danger'>{this.state.errors.skuNumber}</div>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='form-group position-relative'>
                                        <Tooltip
                                            arrow
                                            title={text.label_tooltip}
                                            placement='top'>
                                            <i className='fas fa-question-circle tooltip-icon'> </i>
                                        </Tooltip>
                                        <TextField
                                            type='text'
                                            id='imageFiles'
                                            name='imageFiles'
                                            label={text.label_upload}
                                            value={this.state.image_name}
                                            fullWidth
                                            autoComplete='off'
                                        />
                                        <label
                                            htmlFor="image"
                                            id="upload-image"
                                        >{text.label_browse}</label>
                                        <TextField
                                            accept='.jpg,.jpeg,.png'
                                            type='file'
                                            id='image'
                                            name='image'
                                            className='avatar d-none'
                                            onChange={this.handleUpload}
                                            fullWidth
                                        />
                                        {this.validator.message('image', this.state.image, 'required')}
                                        <div className='text-danger'>{this.state.errors.image}</div>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='name'
                                            name='name'
                                            label={text.label_product}
                                            onChange={(e) => this.handleChange(e, 'name')}
                                            value={this.state.name}
                                            fullWidth
                                        />
                                        {this.validator.message('name', this.state.name, 'required')}
                                        <div className='text-danger'>{this.state.errors.name}</div>
                                    </div>
                                </div>
                                <div className='col-md-6 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            select
                                            id='storage'
                                            name='storage'
                                            label={text.label_storage}
                                            onChange={(e) => this.handleChange(e, 'storage')}
                                            value={this.state.storage}
                                            fullWidth
                                        >
                                            {this.state.storageList.map((option, idx) => (
                                                <MenuItem key={idx} value={option}>
                                                    {this.formatStorage(option)}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {this.validator.message('storage', this.state.storage, 'required')}
                                        <div className='text-danger'>{this.state.errors.storage}</div>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='row align-items-center'>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <TextField
                                                    select
                                                    id='category'
                                                    name='category'
                                                    label={text.label_category}
                                                    onChange={(e) => this.handleChange(e, 'category')}
                                                    value={this.state.category}
                                                    fullWidth
                                                >
                                                    <MenuItem value='Beras'>
                                                        Beras
                                                    </MenuItem>
                                                    <MenuItem value='Bumbu Dan Sambal'>
                                                        Bumbu Dan Sambal
                                                    </MenuItem>
                                                    <MenuItem value='Daging Ayam'>
                                                        Daging Ayam
                                                    </MenuItem>
                                                    <MenuItem value='Daging Sapi'>
                                                        Daging Sapi
                                                    </MenuItem>
                                                    <MenuItem value='Es Krim'>
                                                        Es Krim
                                                    </MenuItem>
                                                    <MenuItem value='Ikan Dan Hasil Laut'>
                                                        Ikan Dan Hasil Laut
                                                    </MenuItem>
                                                    <MenuItem value='Makanan Siap Masak'>
                                                        Makanan Siap Masak
                                                    </MenuItem>
                                                    <MenuItem value='Makanan Siap Saji'>
                                                        Makanan Siap Saji
                                                    </MenuItem>
                                                    <MenuItem value='Minuman'>
                                                        Minuman
                                                    </MenuItem>
                                                    <MenuItem value='Oleh-Oleh'>
                                                        Oleh-Oleh
                                                    </MenuItem>
                                                    <MenuItem value='Roti Dan Kue'>
                                                        Roti Dan Kue
                                                    </MenuItem>
                                                    <MenuItem value='Selai Dan Mentega'>
                                                        Selai Dan Mentega
                                                    </MenuItem>
                                                    <MenuItem value='Lainnya'>
                                                        Lainnya
                                                    </MenuItem>
                                                </TextField>
                                                {this.validator.message('category', this.state.category, 'required')}
                                                <div className='text-danger'>{this.state.errors.category}</div>
                                            </div>
                                        </div>

                                        {this.state.category === 'Lainnya' &&
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <TextField
                                                        type='text'
                                                        id='name'
                                                        name='name'
                                                        label={text.label_category}
                                                        onChange={(e) => this.handleChange(e, 'category_other')}
                                                        value={this.state.category_other}
                                                        fullWidth
                                                    />
                                                    <div className='text-danger'>{this.state.errors.category_other}</div>
                                                </div>
                                            </div>
                                        }

                                        <div className='col-md-4'>
                                            <div className='form-group'>
                                                <TextField
                                                    type='number'
                                                    id='weight'
                                                    name='weight'
                                                    label={text.label_weight}
                                                    onChange={(e) => this.handleChange(e, 'weight')}
                                                    value={this.state.weight}
                                                    fullWidth
                                                />
                                                {this.validator.message('weight', this.state.weight, 'required')}
                                                <div className='text-danger'>{this.state.errors.weight}</div>
                                            </div>
                                        </div>
                                        <div className='col-md-2 pl-0'>
                                            <span className='info'>Grams</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 mt-3 mb-2'>
                                    <div className='alert-warning'>
                                        <p className='mb-0'>{text.product_alert}!</p>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='row align-items-center'>
                                        <div className='col-md-3'>
                                            <div className='form-group position-relative'>
                                                <i className='fas fa-question-circle tooltip-icon'> </i>
                                                <div className='tooltip-image'>
                                                    <div className='d-flex justify-content-between mb-2'>
                                                        <span>Horisontal</span>
                                                        <span>Vertikal</span>
                                                    </div>
                                                    <img src={Length} alt='length' className='img-fluid' />
                                                </div>
                                                <TextField
                                                    type='text'
                                                    id='length'
                                                    name='length'
                                                    label={text.label_length}
                                                    onChange={(e) => this.handleChange(e, 'length')}
                                                    value={this.state.length}
                                                    InputProps={{
                                                        inputComponent: this.NumberFormatCustom,
                                                    }}
                                                    fullWidth
                                                />
                                                {this.validator.message('length', this.state.length, 'required|numeric')}
                                                <div className='text-danger'>{this.state.errors.length !== 0 && this.state.errors.length}</div>
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <div className='form-group position-relative'>
                                                <i className='fas fa-question-circle tooltip-icon'> </i>
                                                <div className='tooltip-image'>
                                                    <div className='d-flex justify-content-between mb-2'>
                                                        <span>Horisontal</span>
                                                        <span>Vertikal</span>
                                                    </div>
                                                    <img src={Width} alt='width' className='img-fluid' />
                                                </div>
                                                <TextField
                                                    type='number'
                                                    id='width'
                                                    name='width'
                                                    label={text.label_width}
                                                    onChange={(e) => this.handleChange(e, 'width')}
                                                    value={this.state.width}
                                                    fullWidth
                                                />
                                                {this.validator.message('width', this.state.width, 'required|numeric')}
                                                <div className='text-danger'>{this.state.errors.width}</div>
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <div className='form-group position-relative'>
                                                <i className='fas fa-question-circle tooltip-icon'> </i>
                                                <div className='tooltip-image'>
                                                    <div className='d-flex justify-content-between mb-2'>
                                                        <span>Horisontal</span>
                                                        <span>Vertikal</span>
                                                    </div>
                                                    <img src={Height} alt='height' className='img-fluid' />
                                                </div>
                                                <TextField
                                                    type='number'
                                                    id='height'
                                                    name='height'
                                                    label={text.label_height}
                                                    onChange={(e) => this.handleChange(e, 'height')}
                                                    value={this.state.height}
                                                    fullWidth
                                                />
                                                {this.validator.message('height', this.state.height, 'required|numeric')}
                                                <div className='text-danger'>{this.state.errors.height}</div>
                                            </div>
                                        </div>

                                        <div className='col-md-3'>
                                            <label className='info'>{text.label_locker}</label>
                                            <span className='d-block'>
                                                {!this.state.loading3 && <span className='info'>{this.state.lockerSizeName !== 0 ? this.state.lockerSizeName : text.label_no_locker}</span>}
                                                {this.state.loading3 && <i className='fa fa-spinner fa-spin'>&nbsp; </i>}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='row align-items-center'>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <TextField
                                                    select
                                                    id='supliedPackaging'
                                                    name='supliedPackaging'
                                                    label={text.label_packaging}
                                                    onChange={(e) => this.handleChange(e, 'supliedPackaging')}
                                                    value={this.state.supliedPackaging}
                                                    fullWidth
                                                >
                                                    <MenuItem value='Vacuum Bag'>
                                                        Vacuum Bag
                                                    </MenuItem>
                                                    <MenuItem value='Plastic Bag'>
                                                        Plastic Bag
                                                    </MenuItem>
                                                    <MenuItem value='Other'>
                                                        Other
                                                    </MenuItem>
                                                </TextField>
                                                {this.validator.message('supliedPackaging', this.state.supliedPackaging, 'required')}
                                                <div className='text-danger'>{this.state.errors.supliedPackaging}</div>
                                            </div>
                                        </div>

                                        {this.state.supliedPackaging === 'Other' &&
                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <TextField
                                                        type='text'
                                                        id='otherpackaging'
                                                        name='otherpackaging'
                                                        label={text.label_other}
                                                        onChange={(e) => this.handleChange(e, 'otherpackaging')}
                                                        value={this.state.otherpackaging}
                                                        fullWidth
                                                    />
                                                    {this.validator.message('otherpackaging', this.state.otherpackaging, 'required')}
                                                    <div className='text-danger'>{this.state.errors.otherpackaging}</div>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='row align-items-center'>
                                        <div className='col-md-4 mb-2'>
                                            <div className='form-group'>
                                                <TextField
                                                    type='number'
                                                    id='shelfLife'
                                                    name='shelfLife'
                                                    label={text.label_shelf}
                                                    onChange={(e) => this.handleChange(e, 'shelfLife')}
                                                    value={this.state.shelfLife}
                                                    fullWidth
                                                />
                                                {this.validator.message('shelfLife', this.state.shelfLife, 'required')}
                                                <div className='text-danger'>{this.state.errors.shelfLife}</div>
                                            </div>
                                        </div>
                                        <div className='col-md-2 pl-0'>
                                            <span className='info'>{text.label_days}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-12 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='price'
                                            name='price'
                                            label={text.label_product_price}
                                            onChange={(e) => this.handleChange(e, 'price')}
                                            value={this.state.price}
                                            InputProps={{
                                                inputComponent: this.NumberFormatCustom,
                                            }}
                                            fullWidth
                                        />
                                        {this.validator.message('price', this.state.price, 'required')}
                                        <div className='text-danger'>{this.state.errors.price}</div>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='description'
                                            name='description'
                                            label={text.label_product_desc}
                                            onChange={(e) => this.handleChange(e, 'description')}
                                            value={this.state.description}
                                            fullWidth
                                            multiline
                                            rows={4}
                                        />
                                        {this.validator.message('description', this.state.description, 'required')}
                                        <div className='text-danger'>{this.state.errors.description}</div>
                                    </div>
                                </div>
                                <div className='col-12 text-center mt-4'>
                                    <Button
                                        variant='contained'
                                        className='mr-3'
                                        onClick={() => this.handleGo('/products')}
                                    >
                                        {text.button_back}
                                    </Button>
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        className=''
                                        onClick={this.handleSubmit}
                                        disabled={this.state.loadingButton}
                                    >
                                        {text.button_add} {this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i>}
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <ToastContainer />
            </div>

        )

    }
}

const mapStateToProps = (state) => {

    return {

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductsAdd));